import {Box,Grid,TextField,Button} from '@mui/material';

const TicketForm = (props) => {

    return (
            <Box marginLeft={2} marginฺBottom={2} sx={{maxWidth:350}}>
                    <h4>This item can't be edit.</h4>
            </Box>
    );
};

export default TicketForm;